var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyTimes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.91327 19H3.15225C1.82169 19 0.739258 17.8785 0.739258 16.5V8.03125C0.739258 6.65271 1.82169 5.53125 3.15225 5.53125H8.91327C10.2438 5.53125 11.3263 6.65271 11.3263 8.03125V16.5C11.3263 17.8785 10.2438 19 8.91327 19ZM3.15225 6.78125C2.48703 6.78125 1.94575 7.34204 1.94575 8.03125V16.5C1.94575 17.1892 2.48703 17.75 3.15225 17.75H8.91327C9.57849 17.75 10.1198 17.1892 10.1198 16.5V8.03125C10.1198 7.34204 9.57849 6.78125 8.91327 6.78125H3.15225ZM13.7393 14.9375V5.5C13.7393 4.12146 12.6568 3 11.3263 3H4.63021C4.29701 3 4.02696 3.27979 4.02696 3.625C4.02696 3.97021 4.29701 4.25 4.63021 4.25H11.3263C11.9915 4.25 12.5328 4.81079 12.5328 5.5V14.9375C12.5328 15.2827 12.8028 15.5625 13.136 15.5625C13.4692 15.5625 13.7393 15.2827 13.7393 14.9375Z",
    fill: "#586370"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2123 12.4375V3C16.2123 1.62146 15.1299 0.5 13.7993 0.5H7.10325C6.77005 0.5 6.5 0.779785 6.5 1.125C6.5 1.47021 6.77005 1.75 7.10325 1.75H13.7993C14.4645 1.75 15.0058 2.31079 15.0058 3V12.4375C15.0058 12.7827 15.2758 13.0625 15.609 13.0625C15.9422 13.0625 16.2123 12.7827 16.2123 12.4375Z",
    fill: "#586370"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyTimes);
export default __webpack_public_path__ + "static/media/copy-times.c4e23c3986145c9811da9b2d6e30d209.svg";
export { ForwardRef as ReactComponent };